import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import { useRootStore } from '@hooks/useRootStore';
import useDevice from '@hooks/useDevice';
import LoginDrawer from './mobile/LoginDrawer';
import LoginDialog from './web/LoginDialog';

interface LoginViewProps {
}

const LoginView: React.FC<LoginViewProps> = observer(({ }) => {
    const { authenticationStore } = useRootStore();
    const { initializeForm, clearFormState } = authenticationStore;
    const { isMobileDevice } = useDevice();

    useEffect(() => {
        initializeForm(true);
        return () => {
            clearFormState()
        }
    }, [])

    return (
        <>
            {isMobileDevice
                ? <LoginDrawer authenticationStore={authenticationStore} />
                : <LoginDialog authenticationStore={authenticationStore} />
            }
        </>
    )
})

export default LoginView;